"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8371],{

/***/ 58371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ fetchEpisodeStatistic; },
/* harmony export */   "$Q": function() { return /* binding */ PushType; },
/* harmony export */   "$S": function() { return /* binding */ postMyEpisode; },
/* harmony export */   "En": function() { return /* binding */ postEpisodeStatistic; },
/* harmony export */   "Lo": function() { return /* binding */ fetchMyEpisodes; },
/* harmony export */   "Qv": function() { return /* binding */ purchaseEpisodeByBalloon; },
/* harmony export */   "T": function() { return /* binding */ postEpisodeRead; },
/* harmony export */   "VD": function() { return /* binding */ previewEpisodeByBalloon; },
/* harmony export */   "YY": function() { return /* binding */ postEpisodeBooking; },
/* harmony export */   "kN": function() { return /* binding */ fetchEpisode; },
/* harmony export */   "lN": function() { return /* binding */ fetchEpisodes; },
/* harmony export */   "pi": function() { return /* binding */ patchMyEpisode; },
/* harmony export */   "qR": function() { return /* binding */ fetchEpisodeStatisticReaders; },
/* harmony export */   "yC": function() { return /* binding */ deleteEpisodeBooking; },
/* harmony export */   "z6": function() { return /* binding */ deleteMyEpisode; },
/* harmony export */   "zt": function() { return /* binding */ fetchMyEpisode; }
/* harmony export */ });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45432);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45874);
/** API */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};



var postMyEpisode = function() {
    var _ref = _asyncToGenerator(function(storyId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/my-stories/".concat(storyId, "/episodes/"), _objectSpread({
                            status: _constants__WEBPACK_IMPORTED_MODULE_1__/* .EpisodeStatus["private"] */ ._$["private"]
                        }, payload))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postMyEpisode(storyId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var deleteMyEpisode = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api["delete"] */ .hi["delete"]("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function deleteMyEpisode(storyId, episodeId) {
        return _ref.apply(this, arguments);
    };
}();
var deleteEpisodeBooking = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api["delete"] */ .hi["delete"]("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/booking/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function deleteEpisodeBooking(storyId, episodeId) {
        return _ref.apply(this, arguments);
    };
}();
var patchMyEpisode = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId, payload) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.patch */ .hi.patch("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/"), payload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function patchMyEpisode(storyId, episodeId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyEpisodes = function() {
    var _ref = _asyncToGenerator(function(storyId, status, ordering) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1, perPage = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/episodes/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            status: status,
                            ordering: ordering,
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyEpisodes(storyId, status, ordering) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyEpisode = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId) {
        var ref, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    if (((ref = data.story) === null || ref === void 0 ? void 0 : ref.version) === 2) {
                        return [
                            2,
                            _objectSpreadProps(_objectSpread({}, data), {
                                story: _objectSpreadProps(_objectSpread({}, data.story), {
                                    isV2Story: true
                                })
                            })
                        ];
                    }
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMyEpisode(storyId, episodeId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEpisodes = function() {
    var _ref = _asyncToGenerator(function(storyId, ordering) {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1, perPage = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat(storyId, "/episodes/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage,
                            ordering: ordering
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchEpisodes(storyId, ordering) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEpisode = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/stories/".concat(storyId, "/episodes/").concat(episodeId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchEpisode(storyId, episodeId) {
        return _ref.apply(this, arguments);
    };
}();
var purchaseEpisodeByBalloon = function() {
    var _ref = _asyncToGenerator(function(param) {
        var storyId, episodeId, voucherId, isAutoApplyVoucher, type, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    storyId = param.storyId, episodeId = param.episodeId, voucherId = param.voucherId, isAutoApplyVoucher = param.isAutoApplyVoucher, type = param.type;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/stories/".concat(storyId, "/episodes/").concat(episodeId, "/purchase-by-balloon/"), {
                            type: type,
                            voucherId: voucherId,
                            isAutoApplyVoucher: isAutoApplyVoucher
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function purchaseEpisodeByBalloon(_) {
        return _ref.apply(this, arguments);
    };
}();
var previewEpisodeByBalloon = function() {
    var _ref = _asyncToGenerator(function(param) {
        var storyId, episodeId, balloon, message, voucherId, _useStoryPass, useStoryPass, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    storyId = param.storyId, episodeId = param.episodeId, balloon = param.balloon, message = param.message, voucherId = param.voucherId, _useStoryPass = param.useStoryPass, useStoryPass = _useStoryPass === void 0 ? false : _useStoryPass;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/stories/".concat(storyId, "/episodes/").concat(episodeId, "/preview-by-balloon/"), {
                            balloon: balloon,
                            message: message,
                            voucherId: voucherId,
                            useStoryPass: useStoryPass
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function previewEpisodeByBalloon(_) {
        return _ref.apply(this, arguments);
    };
}();
var postEpisodeRead = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId, readData) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/stories/".concat(storyId, "/episodes/").concat(episodeId, "/read/"), readData)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postEpisodeRead(storyId, episodeId, readData) {
        return _ref.apply(this, arguments);
    };
}();
var PushType;
(function(PushType) {
    PushType["default"] = "DF";
    PushType["custom"] = "CUS";
})(PushType || (PushType = {}));
var postEpisodeBooking = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId, payload) {
        var newPayload, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    newPayload = _objectSpreadProps(_objectSpread({}, payload), {
                        booked: payload.booked.toISOString(),
                        pushBody: payload.pushType === PushType.custom ? payload.pushBody : undefined
                    });
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/booking/"), newPayload)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postEpisodeBooking(storyId, episodeId, payload) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEpisodeStatistic = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/statistic/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchEpisodeStatistic(storyId, episodeId) {
        return _ref.apply(this, arguments);
    };
}();
var postEpisodeStatistic = function() {
    var _ref = _asyncToGenerator(function(param) {
        var storyId, episodeId, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    storyId = param.storyId, episodeId = param.episodeId;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/statistic/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postEpisodeStatistic(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchEpisodeStatisticReaders = function() {
    var _ref = _asyncToGenerator(function(storyId, episodeId) {
        var lastEvaluatedKey, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    lastEvaluatedKey = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "";
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/my-stories/".concat(storyId, "/episodes/").concat(episodeId, "/statistic/readers/").concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_2__/* .toQueryString */ .UK)({
                            lastEvaluatedKey: lastEvaluatedKey
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchEpisodeStatisticReaders(storyId, episodeId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ })

}]);